import { createSelector } from "reselect";
import { woundAssessmentProgressChartDataSelector } from "../wound_assessment_progress_chart_data_selector";

export const woundAssessmentProgressChartDataLoadStateSelector = createSelector(
  woundAssessmentProgressChartDataSelector,
  chartData => chartData.loadState
);
